
const primary = '#6af0d0'
const primaryDark = '#323D5C'
const greyLight = '#f5f5f5'
const greyDark = '#6F6069'
const light = '#ffffff'
const dark = '#000000'

const fontSizes = [
  16, 18, 22, 26, 32, 39, 50, 74
]
const space = [
  0, 4, 8, 16, 32, 64, 128, 256
]

const sans = '"WorkSans", system-ui, sans-serif'

export default {
  fontSizes: fontSizes,
  space: space,
  fonts: { sans },
  breakpoints: ['40em', '52em', '64em'],
  colors: {
    primary: primary,
    primaryDark: primaryDark,
    light: light,
    greyLight: greyLight,
    greyDark: greyDark,
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .225)',
    large: '0 0 24px rgba(0, 0, 0, .225)'
  },
  missionColors: ['#c5ffdf','#587cff','#fffbb8'],
  buttons: {
    primary: {
      color: '#fff',
      backgroundColor: primary,
      '&:hover': {
        color: '#fff',
        backgroundColor: primaryDark,
      }
    },
    white: {
      color: '#fff',
      backgroundColor: 'rgba(255,255,255,0.2)',
      boxShadow: 'inset 0 0 0 2px',
      fontWeight: 400,
      '&:hover': {
        color: primary,
        backgroundColor: '#fff'
      }
    }
  },
  cards: {
    grey: {
      backgroundColor: greyLight,
    },
    pricing: {
      border: '3px solid ' + primary,
      padding: space[4],
      textAlign: 'center',
    },
    primary: {
      padding: space[4],
      textAlign: 'center',
      backgroundColor: primary,
      color: 'white',
      boxShadow: '0 0 24px rgba(0, 0, 0, .125)',
    },
    primaryDark: {
      padding: space[4],
      textAlign: 'center',
      backgroundColor: primaryDark,
      color: 'white',
      boxShadow: '0 0 24px rgba(0, 0, 0, .125)',
    }
  },
  Heading: {
    fontFamily: sans,
    color: dark,
  },
  headings: {
    h1: {
      fontSize: fontSizes[7],
      fontWeight: 700,
    },
    h2: {
      fontSize: fontSizes[5],
      fontWeight: 400
    },
    h3: {
      fontSize: fontSizes[5],
      fontWeight: 700,
    },
    h4: {
      fontSize: fontSizes[3],
      fontWeight: 700,
    },
    hero: {
      fontWeight: 500,
    },
    heroSubtitle: {
      fontWeight: 400,
    },
    counter: {
      fontWeight: 600,
    }
  }
}